import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import type { AssessmentScoreTableProps } from "./types";

function IntegrityScoreTable({ heading, rows }: AssessmentScoreTableProps) {
  return (
    <TableContainer sx={{ overflowX: "auto" }}>
      <Table
        sx={{
          minWidth: 860,
          tableLayout: "fixed",
          border: 0.5,
          borderColor: "brand.carbon",
          "& th, & td": {
            borderColor: "brand.carbon",
            borderRight: 1,
          },
          "& th:last-child, & td:last-child": { borderRight: 0 },
          "& tbody tr:last-child td": { borderBottom: 0 },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "34%", p: 1.5, fontWeight: 500 }}>
              {heading}
            </TableCell>
            <TableCell
              align="center"
              sx={{ width: 160, p: 1.5, fontWeight: 500 }}
            >
              Score
            </TableCell>
            <TableCell sx={{ p: 1.5, fontWeight: 500 }}>Evidence</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.key}>
              <TableCell sx={{ p: 2, verticalAlign: "top" }}>
                <Typography
                  sx={{ fontWeight: 700, mb: row.description ? 1 : 0 }}
                >
                  {row.label}
                </Typography>
                {row.description ? (
                  <Typography sx={{ whiteSpace: "pre-wrap" }}>
                    {row.description}
                  </Typography>
                ) : null}
              </TableCell>

              <TableCell
                align="center"
                data-testid={row.scoreTestId}
                data-missing={row.scoreInvalid ? "true" : "false"}
                sx={{ p: 2, verticalAlign: "middle" }}
              >
                <Box sx={{ minWidth: 0 }}>{row.score}</Box>
              </TableCell>

              <TableCell
                data-testid={row.evidenceTestId}
                data-missing={row.evidenceInvalid ? "true" : "false"}
                sx={{ p: 2, verticalAlign: "top" }}
              >
                {row.evidence}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default IntegrityScoreTable;
